module.exports = __webpack_public_path__ + "media/images/icon_list/like_filled-07957f40fb3dfbd50a8599a0d1865486.svg";